import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

export class DppInfoDialogComponent implements ng.IController {
  public modalInstanceService: ng.ui.bootstrap.IModalInstanceService = this as any;
  public resolve: {
    title: string,
    message: string
  };

  public onClose() {
    this.modalInstanceService.close();
  }
}

angular.module('naut').component('dppInfoDialog', {
  template: require('./dpp-info-dialog.component.html'),
  controller: DppInfoDialogComponent,
  controllerAs: 'ctrl',
  bindings: {
    resolve: '<',
    close: '&'
  }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/dpp-info-dialog/dpp-info-dialog.component.ts